import {
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  GET_PREVIEW_ASYNC,
  RESET_MANAGER,
  SET_PRESELECTED_LOCAL_ID,
  SET_SCENARIO_PREVIEW_SWITCHER,
  TEST_SCENARIO_ASYNC,
} from './constants'

const initialState = {
  data: {},
  scenarioPreviewSwitcher: false,
  previewLoader: false,
  testLoader: false,
  testMessage: '',
  testError: '',
  error: null,
  profilesSuggestions: [],
  preselectedLocaleId: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_MANAGER:
      return {
        ...initialState,
        previewLoader: false,
        testMessage: null,
        testLoader: false,
        testError: null,
        preselectedLocaleId: null,
      }
    case TEST_SCENARIO_ASYNC.INITIATE:
      return {
        ...state,
        testLoader: true,
        testError: null,
        testMessage: null,
      }
    case TEST_SCENARIO_ASYNC.SUCCESS:
      return {
        ...state,
        testLoader: false,
        testError: null,
        testMessage: action.payload.data.messageString,
      }
    case TEST_SCENARIO_ASYNC.ERROR:
      return {
        ...state,
        testLoader: false,
        testError: action.error.detail,
        testMessage: null,
      }
    case FETCH_PROFILES_SUGGESTIONS_ASYNC.INITIATE:
      return { ...state, error: null }
    case FETCH_PROFILES_SUGGESTIONS_ASYNC.SUCCESS:
      return {
        ...state,
        profilesSuggestions: action.payload.data,
      }
    case FETCH_PROFILES_SUGGESTIONS_ASYNC.ERROR:
      return {
        ...state,
        error: action.error.response ? action.error.response.message : null,
      }
    case FETCH_PROFILES_SUGGESTIONS_ASYNC.CANCEL:
      return { ...state, profilesSuggestions: [] }
    case GET_PREVIEW_ASYNC.INITIATE:
      return {
        ...state,
        error: null,
        previewLoader: true,
      }
    case GET_PREVIEW_ASYNC.SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        previewLoader: false,
      }
    case GET_PREVIEW_ASYNC.ERROR:
      return {
        ...state,
        error: action.error.detail,
        previewLoader: false,
      }
    case SET_SCENARIO_PREVIEW_SWITCHER:
      return {
        ...state,
        scenarioPreviewSwitcher: action.payload.value,
      }
    case SET_PRESELECTED_LOCAL_ID:
      return {
        ...state,
        preselectedLocaleId: action.payload.value,
      }
    default:
      return state
  }
}
